<template>
  <div class="custom-select" :tabindex="tabindex" @blur="open = false">
    <div class="selected open" :class="{ open: open }" @click="open = !open">
      <span>{{ trimSelected(selected) }}</span>
      <i class="far fa-angle-down"></i>
    </div>
    <div class="items" :class="{ selectHide: !open }">
      <template v-for="(option, i) of options">
      <div
        v-if="option.visible"
        :key="i"
        @click="
          selected = option.text;
          open = false;
          $emit('onSelect', option);
        "
      >
        {{ option.text }}
      </div>
      </template>
    </div >
  </div >
</template >

<script>
export default {
  props: {
    options: {
      type: Array,
      required: true,
    },
    value: {
      //type: String,
      required: false,
      default: null,
    },
    placeholder: {
      type: String,
      required: false,
      default: '',
    },
    tabindex: {
      type: Number,
      required: false,
      default: 0,
    },
  },
  data() {
    return {
      selected: this.placeholder,
      open: false,
    };
  },
  mounted() {
    let option = this.options.find( option => this.value == option.value);
    if(option){
      this.selected = option.text;
    }
    this.setPlaceholder();
  },
  updated() {
    this.setPlaceholder();
  },
  watch: {
    value(newVal) {
      const option = this.options.find(o => o.value == newVal);
      if(option) this.selected = option.text;
      else this.selected = this.placeholder;
    }
  },
  methods: {
    trimSelected: function(selected){
        if(selected.length <= 18 ){
            return selected;
        } else{
            return selected.slice(0, 15) + '...';
        }
    },
    setPlaceholder() {
      if(this.value === null) {
        this.selected = this.placeholder;
      }
    },
  }
};
</script>

